import React from 'react'

import './RowText.scss'

interface IProps {
  title: string
  value: string
  customTitleStyle?: React.CSSProperties
  customValueStyle?: React.CSSProperties
}

export function RowText(props: IProps) {
  return (
    <div className="row-text">
      <p className="row-text__title" style={props.customTitleStyle}>
        {props.title}
      </p>
      <p className="row-text__value technical" style={props.customValueStyle}>
        <span>{props.value}</span>
      </p>
    </div>
  )
}
